import { Component, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { OrderFlowAuthService } from './order-flow-auth.service';
import { Router } from '@angular/router';
import { SpinnerComponent } from '../shared/spinner.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-login',
  imports: [SpinnerComponent],
  template: `
    <div class="of-error-page">
      <div class="card border shadow-sm bg-body" style="--bs-card-border-radius: 0.9rem; max-width: 420px; width: 100%">
        <div class="card-body d-flex flex-column align-items-center gap-3 text-center py-4 px-4">
          @if (error(); as error) {
            <i class="bi bi-shield-exclamation text-danger fs-3"></i>
            <div>
              <h6 class="mb-1 fw-semibold">Sign-in failed</h6>
              <p class="text-muted mb-0 small">{{ error }}</p>
            </div>
            <button type="button" class="btn btn-sm btn-primary d-flex align-items-center gap-1" (click)="login()">
              <i class="bi bi-box-arrow-in-right"></i> Try again
            </button>
          } @else {
            <of-spinner [diameter]="28"></of-spinner>
            <p class="text-muted mb-0 small">Please complete the interactive login in the popup window.</p>
          }
        </div>
      </div>
    </div>
  `
})
export class LoginComponent implements OnInit {
  private authService = inject(OrderFlowAuthService);
  private router = inject(Router);

  // Written from a subscribe error callback, so it has to be a signal for the failure
  // state to render at all under OnPush + zoneless.
  public readonly error = signal<string | null>(null);

  public ngOnInit(): void {
    setTimeout(() => {
      if (this.authService.loggedIn) {
        this.router.navigate(['/']);
      }
    }, 500);
  }

  public login(): void {
    if (this.authService.loggedIn) {
      this.router.navigate(['/']);
    } else {
      this.error.set(null);
      this.authService.login$().subscribe({
        error: (err) => this.error.set(err instanceof Error ? err.message : String(err))
      });
    }
  }
}
